import DetailViewContentElement from "../../../common/models/detailView/elements/detailViewContentElement";

export default class DocumentLink extends DetailViewContentElement {
  linked_document_id: number;
  linked_document: {title: string} = {title: "Stub"};

  constructor() {
    super();
    this.defineProperty("linked_document_id", null)
  }
}